var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCanada = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 57,
  height: 57,
  viewBox: "0 0 57 57",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1541_10296)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.5 57C44.2401 57 57 44.2401 57 28.5C57 12.7599 44.2401 0 28.5 0C12.7599 0 0 12.7599 0 28.5C0 44.2401 12.7599 57 28.5 57Z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.0003 28.5002C57.0003 17.201 50.4247 7.438 40.8916 2.82812V54.1721C50.4247 49.5623 57.0003 39.7993 57.0003 28.5002Z",
  fill: "#D80027"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 28.5002C0 39.7993 6.5756 49.5623 16.1087 54.1722V2.82812C6.5756 7.438 0 17.201 0 28.5002Z",
  fill: "#D80027"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.4565 32.2174L38.4129 29.7392L35.9347 28.5001V26.0218L30.9782 28.5001L33.4565 23.5435H30.9782L28.4999 19.8262L26.0216 23.5435H23.5434L26.0216 28.5001L21.0651 26.0218V28.5001L18.5869 29.7392L23.5434 32.2174L22.3043 34.6957H27.2608V38.4131H29.739V34.6957H34.6955L33.4565 32.2174Z",
  fill: "#D80027"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1541_10296"
}, /*#__PURE__*/React.createElement("rect", {
  width: 57,
  height: 57,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCanada);
export { ForwardRef as ReactComponent };